import { render } from "./ItemMenuMovil.vue?vue&type=template&id=196093ae&scoped=true"
import script from "./ItemMenuMovil.vue?vue&type=script&lang=js"
export * from "./ItemMenuMovil.vue?vue&type=script&lang=js"

import "./ItemMenuMovil.vue?vue&type=style&index=0&id=196093ae&scoped=true&lang=scss"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196093ae"]])

export default __exports__